export const URL_TOP_100_ALBUMS = `https://itunes.apple.com/us/rss/topalbums/limit=100/json`;
